import {
  SALE_CHANNELS,
  SALE_PAYMENT_METHODS,
  SALE_PAYMENT_STATUSES,
} from "@artisancode/api-types";
import { z } from "zod";

import { todayIso } from "./sale-utils";

export const lineSchema = z.object({
  productId: z.string().min(1, "Produk wajib dipilih"),
  qty: z.number().int().min(1),
  sellingPrice: z.number().min(0),
});

export const saleSchema = z.object({
  date: z.string().min(1, "Tanggal wajib diisi"),
  channel: z.enum(SALE_CHANNELS),
  customerName: z.string().optional(),
  transactionCode: z.string().optional(),
  lines: z.array(lineSchema).min(1, "Minimal satu produk"),
  paymentStatus: z.enum(SALE_PAYMENT_STATUSES),
  paymentMethod: z.enum(SALE_PAYMENT_METHODS),
  notes: z.string().optional(),
  workspaceId: z.string().optional(),
});

export type SaleFormValues = z.infer<typeof saleSchema>;
export type SaleLineFormValues = z.infer<typeof lineSchema>;

export const emptySaleLine: SaleLineFormValues = {
  productId: "",
  qty: 1,
  sellingPrice: 0,
};

export const defaultSaleValues: SaleFormValues = {
  date: todayIso(),
  channel: "office",
  customerName: "",
  transactionCode: "",
  lines: [emptySaleLine],
  paymentStatus: "paid",
  paymentMethod: "cash",
  notes: "",
  workspaceId: "",
};
